module.exports = __webpack_public_path__ + "img/braking.58526857.svg";